/**
 *
 * Plugin for Enhanced Ecommerce
 * - 1. Product Impressions
 * - 2. Product Clicks
 * - 3. Add / Remove from Cart
 * - 4. Promotion Impressions
 * - 5. Promotion Clicks
 * What is not included here is present in global/__google_tag_manager.html
 */

(function ( $ ) {
    'use strict';

    var dataLayer = window.dataLayer || [],
        contProductImpressions = 0;

    function parseCategoryNames( categories ){
        var categoryArray = _.map( categories, function( object ){ return object.name;} );
        return categoryArray.join(' / ');
    }

    /**
     * 1. Product Impressions - Every time a product is renedered
     *
     * Required event: zg.getProductInfo.productCreated
     * Required data: element, options, product
     */
    $( document ).on( 'zg.getProductInfo.productCreated', function ( e, element, options, product ) {

    } );

    /**
     * 2. Product Clicks
     *
     * To track the link, be sure that all link tag have the attr data-zg-role="product-link"
     */
    $( document ).on( 'click', '[data-zg-role="product-link"]', function(){

        if( this.attributes.href ) {

            var parent = $( this ).closest( '[data-zg-role="product"]' ).data( 'zg.product' );
            var productObj = parent.product;
            var categoryNames = parseCategoryNames( productObj.categories );

            dataLayer.push({
                'event': 'productClick',
                'ecommerce': {
                    'click': {
                        'products': [{
                            'name': productObj.name || '', // Name or ID is required.
                            'id': productObj.id || '',
                            'category': categoryNames || '',
                            'price': productObj.price.sell || ''
                        }]
                    }
                }
            });
        }
    });

    /**
     * 3. Add / Remove from Cart
     *
     * Required event: zg.product.addedToCart
     * Required data: status, productObj, dataSent
     */
    $( document ).on( 'zg.product.addedToCart', function ( e, status, productObj, dataSent ) {
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        console.log("add_to_cart");
        dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            currency: productObj.price.currency,
            value: productObj.price.sell || '',
            items: [
                {
                    item_id: productObj.id || '',
                    item_name: productObj.name || '',
                    item_brand: productObj.brand || BRAND,
                    item_variant: dataSent.sku || '',
                    price: productObj.price.sell || '',
                    quantity: dataSent.quantity || ''
                }
            ]
        }
        });
        /*dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': productObj.price.currency,
                'add': { // 'add' actionFieldObject measures.
                    'products': [{ //  adding a product to a shopping cart.
                        'name': productObj.name || '',
                        'id': productObj.id || '',
                        'price': productObj.price.sell || '',
                        'brand': productObj.brand || BRAND, // Mind to have "BRAND" variable added in global/_common_js_includes.html for adding the "Brand" property in Category page
												'category': window.JS_TRANSLATIONS['category.name'],
                        'variant': dataSent.sku || '',
                        'quantity': dataSent.quantity || ''
                    }]
                }
            }
        });*/

    } );
    /**
     * Required event: zg.product.removedFromCart
     * Required data: type, status, data
     */
    $( document ).on( 'zg.product.removedFromCart', function ( e, type, status, data ) {

        if( type === 'cart' ){
            // Measure the removal of a product from a shopping cart.
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
                currency: SGL_JS_CURRENCY,
                items: [
                {
                item_id: data.product_id || '',
                item_variant: data.sku || '',
                quantity: data.quantity || ''
                }
                ]
            }
            });
        }

    } );

    /**
     * For Cart page
     * When a product is removed from cart we are submitting a form. Also when we submitting a form we should trigger zg.product.removedFromCart
     */
    $( document ).on( 'submit', '[data-zg-role="list-item-remove"]', function () {
        var $this = $(this),
            data  = $this.data();

        var dataToSend = {
            'product_id': 	data.id || 0,
            'sku': 					data.sku || 0,
            'quantity': 		data.quantity || 1
        };

        $( document ).trigger( 'zg.product.removedFromCart', ['cart', null, dataToSend] );
    } );

    /**
     * 4. Promotion Impressions
     *
     * To track the promo present in page, be sure that all promo div have the attr data-zg-role="promotion"
     */
    $( '[data-zg-role="promotion"]' ).each(function( index, element ) {

        dataLayer.push({
            'ecommerce': {
                'promoView': {
                    'promotions': [
                        {
                            'id': element.dataset.promoId || '', // Name or ID is required.
                            'name': element.dataset.promoName || '',
                            'position': element.dataset.promoPosition || ''
                        }]
                }
            }
        });
    });

    /**
     * 5. Promotion Clicks
     *
     * To track the promo link, be sure that all link tag have the attr data-zg-role="promotion-link"
     * Required attr: data-promo-id="x", data-promo-name="x", data-position='x'
     */
    $( document ).on( 'click', '[data-zg-role="promotion-link"]', function() {
        if( this.attributes.href ){
            dataLayer.push({
                'event': 'promotionClick',
                'ecommerce': {
                    'promoClick': {
                        'promotions': [
                            {
                                'id': this.dataset.promoId || '', // Name or ID is required.
                                'name': this.dataset.promoName || '',
                                'position': this.dataset.promoPosition || ''
                            }]
                    }
                }
            });
        }
    });

    let payment_type = '';
    if($('.page_confirm')){
        $( document ).on( 'zg.selectPayment.paymentReady', function(e,paymentInfo){
            payment_type = paymentInfo;
            
        } );
        $('[data-role="syn-checkout"]').click(function(e){
            e.preventDefault();
            if (typeof begin_checkout === "function") {
                begin_checkout();
            }
            let loc = $(this).attr('href');
            setTimeout(function(){
                location.href = loc;
            },600);
            

        });
        
        $('[data-payment-checkout="payment"]').click(function(e){
             e.preventDefault();
             e.stopPropagation();
            /*let paymentType=$(this).attr('data-payment-type');*/
        

            let paymentType="Paypal";
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            if (typeof cart_items != "undefined"){
                let _cart_items  = cart_items ?? {};

                dataLayer.push({
                event: "add_payment_info",
                    ecommerce: {
                        currency: SGL_JS_CURRENCY,
                        value: SGL_JS_TOTAL_SUM,
                        coupon: "",
                        payment_type: paymentType,
                        items: _cart_items ?? {}
                    },user_data:USER_DATA
                });
            }
            let loc = $(this).attr('href');
            location.href = loc;
     
        });
        $( document ).on( 'zg.selectShipping.shippingReady',function(e,data,val,total) {
            console.log(val);
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
            event: "add_shipping_info",
            ecommerce: {
                currency: val.currency,
                value: total,
                coupon: "",
                shipping_tier: val.name,
                items: cart_items
                },user_data:USER_DATA
            });
        });
    }

    /*category VIEW */
    if (typeof window.category_view_item_list !== "undefined") {
        console.log(window.category_view_item_list);
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
        event: "view_item_list",
        ecommerce: {
            item_list_id: category_view_item_list,
            item_list_name: category_view_item_list,
        }
        });
    }
    /*PRODUCT VIEW */

	if (typeof window.product_view_item !== "undefined") {
        console.log('product page');
		var product = product_view_item;
		var dataLayer = window.dataLayer || [];
		var categoryNames = parseCategoryNames(product.categories);
            var list;

            var cats =[];
            for(var k in product.categories){
                cats.push(product.categories[k].name)
            }
            var discount =0;
            discount = product.price.to_discount -product.price.sell ;
            if(discount <= 0) {
                discount = 0;
            }
            let promotion_id='';
            let promotion_name='';
            if(typeof product.promotions !== 'undefined' && product.promotions !== null  && typeof product.promotions.applied !== 'undefined'){
                promotion_id=Object.keys(product.promotions.applied)[0];
                promotion_name='Promo';
            }
            if(typeof product.promotion !== 'undefined' && product.promotion !== null  && typeof product.promotion.applied !== 'undefined'){
                promotion_id=Object.keys(product.promotion.applied)[0];
                promotion_name='Promo';
            }
            setTimeout(function(){
                /*TEST ID_VARIANT */
                const el2 = document.querySelector('.product-options:first-of-type [data-option-id="2"] .active');
                const el4 = document.querySelector('.product-options:first-of-type [data-option-id="4"] .active');

                const opt2 = el2 ? el2.dataset.value : null; // valore per option-id 2
                const opt4 = el4 ? el4.dataset.value : null; // valore per option-id 4

                // 2) cerca la SKU corrispondente
                let skuKey = null;
                const skusSource = product.skus;

                // se product.skus è un array di oggetti [{ "3202810": { options: {...} } }, ...]
                if (Array.isArray(skusSource)) {
                    for (const skuObj of skusSource) {
                        const key = Object.keys(skuObj)[0];
                        const opts = skuObj[key].options || {};
                        if (String(opts[2]) === String(opt2) && String(opts[4]) === String(opt4)) {
                        skuKey = key;
                        break;
                        }
                    }

                // se product.skus è un oggetto { "3202810": { options: {...} }, ... }
                } else {
                    for (const [key, data] of Object.entries(skusSource)) {
                        const opts = data.options || {};
                        if (String(opts[2]) === String(opt2) && String(opts[4]) === String(opt4)) {
                        skuKey = key;
                        break;
                        }
                    }
                }

                // 3) risultato
                console.log('opt2:', opt2, 'opt4:', opt4, 'skuKey:', skuKey);

                
        
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                event: "view_item",
                ecommerce: {
                    currency: SGL_JS_CURRENCY,
                    value: product.price.sell,
                    items: [{
                        promotion_id:  promotion_id ,
                        promotion_name: promotion_name,
                        item_id: product.id || '',
                        item_name: product.name || '',
                        affiliation: '',
                        coupon: '',
                        currency: product.price.currency,
                        discount: discount,
                        index: 0,
                        item_brand: product.brand || BRAND, 
                        item_category: cats[0] || '',
                        item_category2: cats[1] || '',
                        item_category3: cats[2] || '',
                        item_category4: cats[3] || '',
                        item_category5: cats[4] || '',
                        item_list_id: 'product_page',
                        item_list_name: 'Product Page',
                        item_variant: skuKey,
                        location_id: '',
                        price: product.price.sell,
                        quantity: 1
                        }]
                    }
                });
            },1500);
	}



}( jQuery ));
